module.exports = __webpack_public_path__ + "media/images/facebook_black-59b930a61bd9a802b8fe785edd3f65c5.svg";